import { FormControl } from '@angular/forms';

export interface ITableNumberGroup {
  pickUpFromCounter: FormControl<boolean>;
  tableNumber: FormControl<string>;
}

export interface ITableNumberGroupValue {
  pickUpFromCounter: boolean;
  tableNumber: string;
}

export interface ITablePickupDialog {
  tableNumber: string | undefined;
  customPickUpOrderText: string | undefined;
  isPickupOnly: boolean | undefined;
}

export const CPickUpTableNumber = 'pick-up';
